/*

  ______   ______ _____ _______ __   _
  |_____] |_____/   |   |_____| | \  |
  |_____] |    \_ __|__ |     | |  \_|

     authentication & authorization

(c) 2006 - 2019 TOYOTA Central Europe <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

"use strict";

const angular = require("angular");

angular
    .module("ROGER")
    //
    .factory("$addressLookup", [
        "$q",
        function ($q) {
            var addressLookup = {};

            addressLookup.lookup = function (text) {
                var result = $q.defer();
                var service = new window.google.maps.places.AutocompleteService();
                service.getQueryPredictions(
                    {
                        input: text,
                        types: ["geocode"]
                    },
                    function (predictions, status) {
                        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                            result.resolve(predictions);
                        } else if (
                            status ===
                            window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS
                        ) {
                            result.resolve([{}]);
                        } else {
                            result.reject();
                        }
                    }
                );
                return result.promise;
            };

            addressLookup.detail = function (placeId) {
                var result = $q.defer();
                var service = new window.google.maps.places.PlacesService(
                    document.getElementById("map")
                );
                service.getDetails(
                    {
                        placeId: placeId
                    },
                    function (place, status) {
                        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                            result.resolve(place);
                        } else {
                            result.reject();
                        }
                    }
                );
                return result.promise;
            };

            return addressLookup;
        }
    ]);
